import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import Logo from "../Logo";

import facebook from "./images/facebook.svg";
import insta from "./images/insta.svg";
import * as styles from "./styles.module.scss";

const SOCIAL_LINKS = [
  {
    name: "Facebook",
    link: {
      bexley: "https://www.facebook.com/share/arisZoPq6NQdaB8C",
      eltham: "https://www.facebook.com/1493776157328385",
    },
    image: facebook,
  },
  {
    name: "Instagram",
    link: {
      bexley: "https://www.instagram.com/rustybucketpub_bexley",
      eltham: "https://www.instagram.com/rustybucketpub_eltham",
    },
    image: insta,
  },
];

const venueOpeningHours = {
  bexley: [
    { day: "Monday", from: "4", to: "9" },
    { day: "Tuesday", from: "4", to: "10" },
    { day: "Wednesday", from: "4", to: "11" },
    { day: "Thursday", from: "4", to: "11" },
    { day: "Friday", from: "12", to: "11" },
    { day: "Saturday", from: "12", to: "11" },
    { day: "Sunday", from: "12", to: "10" },
  ],
  eltham: [
    { day: "Monday", from: "12", to: "10" },
    { day: "Tuesday", from: "12", to: "10" },
    { day: "Wednesday", from: "12", to: "11" },
    { day: "Thursday", from: "12", to: "11" },
    { day: "Friday", from: "12", to: "11" },
    { day: "Saturday", from: "12", to: "11" },
    { day: "Sunday", from: "12", to: "10" },
  ],
};

const FooterVenue = ({ location }) => {
  const openingHours = venueOpeningHours[location];

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.logoContainer}>
          <Logo />
        </div>
        <div className={styles.sectionsContainer}>
          <OpeningHours openingHours={openingHours} />
          <FindUs location={location} />
          <TalkToUs location={location} />
          <FollowUs location={location} />
        </div>
      </div>
      <Legal />
    </div>
  );
};

FooterVenue.propTypes = {
  location: PropTypes.string,
};

const Heading = ({ title }) => <h2 className={styles.heading}>{title}</h2>;

Heading.propTypes = {
  title: PropTypes.string,
};

const OpeningHours = ({ openingHours }) => (
  <div className={styles.section}>
    <Heading title="Opening Hours" />
    <div className={styles.openingHoursWrapper}>
      <div className={styles.openingHoursContainer}>
        {openingHours.map(({ day, from, to }) => (
          <Day key={day} day={day} from={from} to={to} />
        ))}
      </div>
    </div>
  </div>
);

OpeningHours.propTypes = {
  openingHours: PropTypes.array,
};

const Day = ({ day, from, to }) => (
  <>
    <div className={styles.dayName}>{day}</div>
    <div className={styles.from}>{from}</div>
    <div className={styles.dash}>-</div>
    <div className={styles.to}>{to}</div>
  </>
);

Day.propTypes = {
  day: PropTypes.string,
  from: PropTypes.string,
  to: PropTypes.string,
};

const FindUs = ({ location }) => {
  const content = {
    bexley: {
      address: "Arch 3, Mill Row, Bexley, London, DA5 1LA",
      gmap: "https://maps.app.goo.gl/qkpprbM6Sur6VW4w5",
    },
    eltham: {
      address: "11 Court Yard, Eltham, London, SE9 5PR",
      gmap: "https://goo.gl/maps/ENjtRUXUigQaxjbT8",
    },
  }[location];

  return (
    <div className={styles.section}>
      <Heading title="Find Us" />
      {content.address.split(", ").map((x) => (
        <>
          {x}
          <br />
        </>
      ))}
      &nbsp;
      <br />
      <a href={content.gmap} target="_blank" rel="noreferrer">
        Google map
      </a>
    </div>
  );
};

FindUs.propTypes = {
  location: PropTypes.string,
};

const TalkToUs = ({ location }) => (
  <div className={styles.section}>
    <Heading title="Talk To Us" />
    <a href={`mailto:${location}@therustybucket.pub`}>
      {location}@therustybucket.pub
    </a>
    {location === "bexley" && (
      <>
        <br />
        <a href="tel:+447777756003">07777 756 003</a>
      </>
    )}
    {location === "eltham" && (
      <>
        <br />
        <a href="tel:+442088595500">020 8859 5500</a>
      </>
    )}
  </div>
);

TalkToUs.propTypes = {
  location: PropTypes.string,
};

// TODO: a11y links
const FollowUs = ({ location }) => (
  <div className={classNames(styles.section, styles.followUsContainer)}>
    <Heading title="Follow Us" />
    {SOCIAL_LINKS.map(({ name, link, image }) => (
      <div className={styles.socialLink} key={name}>
        <a href={link[location]} target="_blank" rel="noreferrer">
          <img src={image} />
        </a>
      </div>
    ))}
  </div>
);

FollowUs.propTypes = {
  location: PropTypes.string,
};

const Legal = () => (
  <div className={styles.legal}>
    &copy; The Rusty Bucket {new Date().getFullYear()}
  </div>
);

export default FooterVenue;
